import NotificationEvent from "../Components/Common/notification-event";

export default class NotificationService {
  static ServiceWorkerEvent = new NotificationEvent("serviceWorker");
}
